/**
 * Where the app talks to its API.
 *
 * In production this is the same origin as the deployed app. In development it
 * is a local server whose port varies per workspace: several Conductor
 * checkouts run side by side, and they used to all default to 3000 — so the
 * loser of that race silently had its requests answered by another workspace.
 *
 * `EXPO_PUBLIC_API_PORT` is set by scripts/dev.mjs before Metro starts, since
 * EXPO_PUBLIC_* values are inlined into the bundle at build time. The 3000
 * fallback keeps a bare `expo start` working.
 */
declare const __DEV__: boolean;

const DEV_API_PORT = process.env.EXPO_PUBLIC_API_PORT || '3000';

/** True when running the web app against a local dev server. */
export function isDevWeb(): boolean {
  return typeof __DEV__ !== 'undefined' && __DEV__ && typeof window !== 'undefined';
}

export function getApiBaseUrl(): string {
  if (isDevWeb()) {
    return DEV_API_ORIGIN;
  }
  // Production: same origin as the deployed app.
  return '';
}

/**
 * The local dev API origin, for the few callers whose production branch is not
 * same-origin and so cannot use getApiBaseUrl().
 */
export const DEV_API_ORIGIN = `http://localhost:${DEV_API_PORT}`;
